import { Navigate, Outlet } from "react-router-dom";

import { FeatureFlagToggle } from "@/domain/_shared/feature-flag/components/feature-flag-toggle";
import { lazyRoute } from "@/routes/lazy-route";

const UserNotificationSettingsPage = lazyRoute(() => import("./user-notification-settings.page"), "UserNotificationSettingsPage");
const UserProfileSettingsPage = lazyRoute(() => import("./user-profile-settings.page"), "UserProfileSettingsPage");
const UserSecuritySettingsPage = lazyRoute(() => import("./user-security-settings.page"), "UserSecuritySettingsPage");

export const userSettingsRoutes = [
  {
    path: "account",
    element: <Outlet />,
    children: [
      { path: "", element: <Navigate to="profile" replace /> },
      {
        path: "profile",
        element: <UserProfileSettingsPage />,
      },
      {
        path: "security",
        element: <UserSecuritySettingsPage />,
      },
      {
        path: "notifications",
        element: (
          <FeatureFlagToggle flag="enable-notification-settings">
            <UserNotificationSettingsPage />
          </FeatureFlagToggle>
        ),
      },
    ],
  },
];
